import styled from 'styled-components'
import { DownloadFile } from 'images/bend'

const DownloadFileBase = styled(DownloadFile)((props) => ({
  fill: props.theme.colors.primary
}))

export default DownloadFileBase
